import axios from 'axios';
import config from '../config';

const api = axios.create({
  baseURL: config.apiUrl,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach token to every request
api.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem('token');
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }
    //console.log('✅ API Response:', requestConfig.method?.toUpperCase(), requestConfig.url);
    console.log('📤 API Request:', requestConfig.method?.toUpperCase(), requestConfig.url);
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.config.url, response.status);
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // FIX: do NOT intercept 401s from auth endpoints — let AuthContext handle those
    //const isAuthEndpoint = originalRequest?.url?.includes('/auth/');
    const fullUrl = `${originalRequest.baseURL || ''}${originalRequest.url || ''}`;

    const isAuthEndpoint =
    fullUrl.includes('/auth/login') ||
    fullUrl.includes('/auth/refresh') ||
    fullUrl.includes('/auth/me');
    
    if (error.response?.status === 401 && !originalRequest._retry && !isAuthEndpoint) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');
        
        if (!refreshToken) {
          throw new Error('No refresh token available');
        }

        //const response = await axios.post(`${config.apiUrl}/auth/refresh`, {
        const response = await api.post('/auth/refresh', {
          refresh_token: refreshToken
        });

        const { access_token } = response.data;
        localStorage.setItem('token', access_token);

        // Retry original request with new token
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return api(originalRequest);

      } catch (refreshError) {
        // Refresh failed — clear storage and redirect
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    console.error('❌ API Error:', error.response || error);
    return Promise.reject(error);
  }
);

export default api;